export const ChartDataPercentage = {
    type: 'horizontalBar',
    data: {
	labels: ['Trinity', 'Leading Brand A', 'Leading Brand B'],
	datasets: [
	    { 
		label: 'Percentage improvement over manual',
		data: [6955, 188, 184],
		backgroundColor: [
		    'rgba(71,183,132,.75)', // Green
		    'rgba(71,183,132,.75)', // Green
		    'rgba(71,183,132,.75)' // Green
		]
	    }
	]
    },
    options: {
	responsive: true,
	lineTension: 1,
	scales: {
	    yAxes: [{
		ticks: {
		    beginAtZero: true,
		    padding: 25,
		}
	    }]
	}
    }
}

export default ChartDataPercentage;
